/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterZSmall = createReactComponent("outline", "letter-z-small", "IconLetterZSmall", [["path", { "d": "M10 8h4l-4 8h4", "key": "svg-0" }]]);

export { IconLetterZSmall as default };
//# sourceMappingURL=IconLetterZSmall.mjs.map
